import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DiscountService } from 'src/app/services/discount.service';
import type { IPreviewCommon } from '@shared/common/data/products';
import type { Observable } from 'rxjs';

@Component({
  selector: 'app-item[product]',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComponent {
  private _product?: IPreviewCommon | Readonly<IPreviewCommon>;

  public discount$?: Observable<string | undefined>;

  @Input() set product(value: typeof this._product) {
    if (!value) return;

    this.discount$ = this._discountService.getDiscount$(value.alias);
    this._product = value;
  }

  get product() {
    return this._product;
  }

  @Output() buttonClick = new EventEmitter<void>();

  constructor(private _discountService: DiscountService) {}

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
